export const env = {
    endpoint: `${import.meta.env.VITE_PROTOCOL}//${import.meta.env.VITE_ENDPOINT}`,
    staticBucket: `${window.location.protocol}//${import.meta.env.VITE_STATIC_BUCKET}`,
    creativePreview: `${window.location.protocol}//${import.meta.env.VITE_BIDDER_ENDPOINT}/creative/preview`,
    debug: import.meta.env.VITE_DEBUG,
    eventlogger: `${window.location.protocol}//${import.meta.env.VITE_EVENT_LOGGER_URL}/event`,
    bidder: `${window.location.protocol}//${import.meta.env.VITE_BIDDER_ENDPOINT}`,
    interfaceId: import.meta.env.VITE_INTERFACE_ID,
    asteriotagUrl: import.meta.env.VITE_ASTERIOTAG_URL,
    asteriotrackUrl: import.meta.env.VITE_ASTERIOTRACK_URL,
    asteriotrackEndpoint: import.meta.env.VITE_ASTERIOTRACK_ENDPOINT
}
